import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { PATHS } from 'src-ironside/app-routing.module';
import { News, NewsRepository } from 'src-ironside/repositories/news.repository';
import { BreadCrumbItem } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';
import { NewsDetailDialogComponent } from 'src-ironside/shared/components/dialogs/news-detail-dialog/news-detail-dialog.component';

interface PageEvent {
    first: number;
    rows: number;
    page: number;
    pageCount: number;
}

@Component({
    selector: 'app-yellow-focus',
    templateUrl: 'yellow-focus.component.html',
    styleUrls: ['./yellow-focus.component.css'],
    providers: [NewsRepository],
})
export class YellowFocusComponent {
    readonly unsubscribe$ = new Subject();

    listYellowFocus: News[];
    totalRecords: number = 120;
    listRows: any[] = [10, 20, 30];
    first: number = 0;

    pageSize: number = 10;

    constructor(
        private newsRepo: NewsRepository,
        private dialog: MatDialog,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.getListYellowFocus();
    }

    get breadCrumb() {
        let breadCrumbs: BreadCrumbItem[] = [
            { name: this.translate.instant('Menu.home'), url: PATHS.home_en },
            { name: this.translate.instant('Menu.yellow-focus') },
        ];
        return breadCrumbs;
    }

    onPageChange(event: PageEvent) {
        this.first = event.first;
        this.getListYellowFocus(event.page + 1);
    }

    getListYellowFocus(page: number = 1) {
        this.newsRepo
            .find(page)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res) => {
                this.listYellowFocus = res.content.map((iNew) => {
                    return { ...iNew, imageURL: iNew?.photo?.[0]?.url ?? iNew?.document?.[0]?.url };
                });
                window.scrollTo(0, 0);
                this.totalRecords = res.meta.totalItems;
            });
    }

    showNewsDetail(id: string | undefined) {
        if (id)
            this.dialog.open(NewsDetailDialogComponent, {
                width: '1100px',
                height: 'auto',
                data: { id: id },
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
